import React from "react";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Icon
} from "semantic-ui-react";
import GridRow from "semantic-ui-react/dist/commonjs/collections/Grid/GridRow";

const Box = ({ currency, componentData }) => {
  const displaySubText = () => {
    if (componentData.percent) {
      let iconName = "caret up";
      let iconColor = "green";
      return (
        <Grid.Row style={styles.heading}>
          <span style={styles.headingOne}>
            <Icon
              style={styles.icon}
              name={iconName}
              type="font-awesome"
              color={iconColor}
            />{" "}
            {componentData.percent} %
          </span>
          <span style={styles.comparision}>
            Change comparison: 7-day Daily Average
          </span>
        </Grid.Row>
      );
    } else if (componentData.bestProgramme) {
      return (
        <Grid.Row style={styles.heading}>
          <div>
            <h5 style={styles.socialHeading}>Connect with Social</h5>
            <div>
              <span style={styles.headingOne}>
                <Icon
                  style={styles.socialMediaIcon}
                  name={componentData.bestProgramme}
                  type="font-awesome"
                  color="blue"
                />{" "}
              </span>
              <span style={styles.socialMediaText}>Facebook Shares</span>
            </div>
          </div>
        </Grid.Row>
      );
    }
    return <Grid.Row />;
  };
  return (
    <Grid.Column verticalAlign="middle">
      <div style={styles.boxMain}>
        <Grid.Row style={styles.heading}>
          <Header as="h5" style={styles.headingText}>
            {componentData.header}
          </Header>
        </Grid.Row>
        <Grid.Row style={styles.textValue}>
          {currency} {componentData.value}
        </Grid.Row>
        {displaySubText()}
      </div>
    </Grid.Column>
  );
};

const styles = {
  boxMain: {
    minHeight: 170,
    marginBottom: 30,
    marginTop: 15,
    paddingBottom: 20,
    paddingTop: 35,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    textAlign: "center",
    boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)"
  },
  comparision: {
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    fontSize: 12,
    marginTop: 5
  },
  heading: {
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: 5
  },
  headingOne: {
    fontSize: 14,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginTop: 17
  },
  headingText: {
    fontSize: 16,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 300,
    marginBottom: 8
  },
  icon: {
    height: 8,
    width: 10,
    justifyContent: "center",
    paddingTop: 0
  },
  textValue: {
    fontSize: 32,
    fontWeight: 400,
    flex: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    fontFamily: "Roboto",
    color: "#313131"
  },
  socialHeading:{
      fontFamily:'Roboto',
      fontWeight:300,
      fontSize:12,
  },
  socialMediaIcon:{
    height:20,
    fontSize:32,
    marginRight:10,
    width:20
  },
  socialMediaText:{
    fontFamily:'Roboto',
    fontWeight:500,
    fontSize:20,  
  }
};

export { Box };



// WEBPACK FOOTER //
// ./src/containers/Loyalty/components/Box.js